export default __webpack_public_path__ + "static/media/length_cage.efe737b6.svg";